export default __webpack_public_path__ + "static/media/background.1e1b5eb6.png";